export const GRAPHQL_URL = 'https://gw5aof3j2jc3rn4r43warf2nrq.appsync-api.us-east-1.amazonaws.com/graphql' 
// RDS: https://gw5aof3j2jc3rn4r43warf2nrq.appsync-api.us-east-1.amazonaws.com/graphql 
// Dynamodb: https://nohg6aahibephiyry3emwxtl4i.appsync-api.us-east-1.amazonaws.com/graphql